var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm._l(_vm.list, function (data) {
        return _c(
          "li",
          [
            _c(
              "b-row",
              [
                _c("b-col", [
                  _c("span", { staticClass: "detail-label" }, [
                    _vm._v(_vm._s(data.title) + " :"),
                  ]),
                ]),
                _vm._v(" "),
                _c("b-col", { staticClass: "detail-value" }, [
                  !data.pipe
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("if_null")(_vm.source[data.attribut]))
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  data.pipe === "in_euro"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("in_euro")(_vm.source[data.attribut]))
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  data.pipe === "sexe"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("sexe")(_vm.source[data.attribut]))
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  data.pipe === "in_minutes"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("in_minutes")(_vm.source[data.attribut])
                          )
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  data.pipe === "sensation"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("sensation")(_vm.source[data.attribut]))
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  data.pipe === "date"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm._f("date")(_vm.source[data.attribut]))
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  data.pipe === "cascade_attribut"
                    ? _c("span", [
                        _vm._v(
                          _vm._s(_vm.source[data.attribut[0]][data.attribut[1]])
                        ),
                      ])
                    : _vm._e(),
                ]),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }